/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-30 19:39:45
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-30 20:14:40
 * @name: 人员模块api
 * @Description: 人员模块api
 * @FilePath: \preSaleNafterSaleBackstage\src\api\admin\admin.api.js
 * @Author: desktop
 */
import apiAdd from "../apiAdd.js";
import apiEdit from "../apiEdit.js";
import apiDelete from "../apiDelete.js";
import apiSearch from "../apiSearch.js";
import axios from 'axios';
import { Message } from "element-ui";

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取管理员列表
 */
export const adminGetList = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/admin/getList.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 添加人员
 */
export const adminAdd = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/admin/add.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 编辑人员
 */
export const adminEdit = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/admin/edit.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 获取管理员信息
 */
export const adminDetail = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.get('/admin/admin/detail.html', data, instance);
}

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 离职
 */
export const adminDelete = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/admin/delete.html', data, instance);
}